import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../login.service';
import { TenantSwitchService } from '../../../services/tenant-switch.service';
import { ToastService } from '../../../services/toast-service';

@Component({
  selector: 'app-switch-exchange',
  templateUrl: './switch-exchange.component.html',
  styleUrls: ['./switch-exchange.component.scss']
})
export class SwitchExchangeComponent implements OnInit {
  loading = true;
  failed = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tenantSwitchService: TenantSwitchService,
    private loginService: LoginService,
    private toastService: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('ex') || '';
    window.history.replaceState({}, document.title, '/auth/switch');

    if (!token) {
      this.handleFailure('TenantSwitch.InvalidToken');
      return;
    }

    this.tenantSwitchService.exchangeToken(token).subscribe({
      next: (response) => {
        this.loginService.setTokenFromSwitch(response.token);
        this.toastService.show({
          type: 'success',
          data: [this.translate.instant('TenantSwitch.SwitchSuccess')]
        });
        window.location.replace('/home');
      },
      error: () => {
        this.handleFailure('TenantSwitch.SwitchFailed');
      }
    });
  }

  private handleFailure(messageKey: string): void {
    this.loading = false;
    this.failed = true;
    this.toastService.show({
      type: 'error',
      data: [this.translate.instant(messageKey)]
    });
    setTimeout(() => this.router.navigate(['/login']), 1500);
  }
}
